module.exports = __webpack_public_path__ + "static/media/christmas-carol-megaways.9f4a8012.gif";